import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';

const LAYOUT_BODY_CLASSES = ['menubar-hoverable', 'header-fixed', 'menubar-pin'];

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html'
})
export class LayoutComponent implements OnInit, OnDestroy {
    constructor(private renderer: Renderer2) { }

    ngOnInit() {
        LAYOUT_BODY_CLASSES.forEach(className => this.renderer.addClass(document.body, className));
    }

    ngOnDestroy() {
        LAYOUT_BODY_CLASSES.forEach(className => this.renderer.removeClass(document.body, className));
    }
}
